<template>
  <!-- https://michalsnik.github.io/aos/ -->
  <v-container>
    <v-card class="mx-auto" max-width="550">
    <v-system-bar  color="pink darken-2"></v-system-bar>
  

      <v-app-bar color="#424242" dark dense @click.stop="$router.push('/')">
        <v-icon>home</v-icon>
        <v-spacer></v-spacer>
        <v-toolbar-title>Microcise</v-toolbar-title>
      </v-app-bar>
   


    <sign-up :toggle='toggle' v-if="formState === 'signUp'"></sign-up>
    

    <sign-in v-if="formState === 'signIn'"></sign-in>


     <div class="text-center grey--text darken-2">
        <v-btn width="50" class="ma-2 pa-0 text-center"  plain color="pink darken-2" 
          @click="toggle">
			{{ formState === 'signUp' ? 'Already signed up? Sign In' : 'Need an account? Sign Up'}}
          </v-btn>
     </div>

</v-card>

  </v-container>


</template>

<script>
import SignUp from './SignUp'
import SignIn from './SignIn'

export default {
  name: 'app',
  data() {
    return {
      formState: 'signIn'
    }
  },
  created() {
      // test if query string (set in the home page buttons)
      if(this.$route.query.action === undefined) {
          // use default - signIn
          this.formStat = 'signIn'
        } else {
          this.formState = this.$route.query.action
        }
    },
  methods: {
    toggle() {
      this.formState === 'signUp' ? this.formState = 'signIn' : this.formState = 'signUp'
    }
  },
  components: {
    SignUp,
    SignIn
  }
}
</script>

<style>
.auth {
  margin: 0 auto;
  width: 460px;
}
.toggle {
  cursor: pointer;
  font-size: 18px;
}
</style>